import Promise from 'bluebird';
import _ from 'lodash';
import { getBrands, getBrandProducts } from 'shared/requests/menu';
import { getBrandHeader, getBrandFooter } from 'shared/requests/brandTemplates';

const BRAND_INDEX_LOADING = 'BRAND_INDEX_LOADING';
const BRAND_INDEX_LOADED = 'BRAND_INDEX_LOADED';
const BRAND_LOADING = 'BRAND_LOADING';
const BRAND_LOADED = 'BRAND_LOADED';

const init = {
  index: [],
  header: '',
  footer: '',
  brandname: '',
  products: [],
  loading: false,
  indexLoading: false
};

export default function(state = init, action = {}) {
  switch (action.type) {
    case BRAND_INDEX_LOADING:
      return { ...state, indexLoading: true };
    case BRAND_INDEX_LOADED:
      return { ...state, indexLoading: false, ...action.payload };
    case BRAND_LOADING:
      return { ...state, loading: true };
    case BRAND_LOADED:
      return { ...state, loading: false, ...action.payload };
    default:
      return state;
  }
}

export function loadBrandIndex() {
  return dispatch => {
    dispatch({ type: BRAND_INDEX_LOADING });
    return dispatch(getBrands()).then(index => {
      return dispatch({ type: BRAND_INDEX_LOADED, payload: { index } });
    });
  };
}

export function loadBrand(slug) {
  return dispatch => {
    dispatch({ type: BRAND_LOADING });
    return Promise.all([
      dispatch(getBrandHeader(slug)),
      dispatch(getBrandFooter(slug)),
      dispatch(getBrandProducts(slug))
    ]).spread((header, footer, { products }) => {
      const brandname = products.length
        ? products[0].company
        : _.startCase(slug);

      return dispatch({
        type: BRAND_LOADED,
        payload: { header, footer, slug, brandname, products }
      });
    });
  };
}
